import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { Tile } from '../../../widgets/tile/tile.component';
import { ExpertsItem } from '../../models/ExpertsItem';
import { AskTheExpertService } from '../../services/ask-the-expert.service';
import { AppToastService } from '../../../widgets/services/app-toast.service';
import { ITileOrder, TileContainerComponent } from '../../../widgets/tile-container/tile-container.component';
import { VideoModalComponent } from '../../../common/video-modal/video-modal.component';
import { CommonModule } from '@angular/common';


@Component({
    selector: 'app-page-ask-the-experts',
    standalone: true,
  imports: [TileContainerComponent, VideoModalComponent, CommonModule],
    templateUrl: './page-ask-the-experts.component.html',
    styleUrls: ['./page-ask-the-experts.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class PageAskTheExpertsComponent implements OnInit {
    title!: string;
    videoDetail!: any;
    experts: ExpertsItem[] = [];
    tileColor: string = "secondary4";
    tileTitle: string = "Ask The Experts";

    tiles: Tile[] = [];
    showPopUp: boolean = false;
    showPopup: boolean = false;
    videoType: string = "";

    constructor(private service: AskTheExpertService, private router: Router, private route: ActivatedRoute, private toaster: AppToastService) {
        this.title = "Ask the Experts";
        //this.commonService.getVideoLnks().then(data => {
        //  this.commonItems = data;    
        //  this.videoDetail = this.commonItems.filter(x => x.pageTitle == this.title)[0].videoUrl;
        //});
    }

    ngOnInit(): void {
        this.retrieveExperts();
        this.videoType = "AskTheExperts";
    }

    retrieveExperts(): void {
        this.service.getAllItems()
            .subscribe(
                data => {
                    this.experts = data;
                    this.loadItems();
                    this.tiles = this.getTiles();
                },
                error => {
                    console.log(error);
                });
    }
    openPopup() {
        this.showPopup = true;
    }

    private loadItems(): void {
        this.experts.forEach((expert) => {
            expert.tile = {
                color: this.tileColor,
                type: "unset",
                title: this.tileTitle,
                size: "xlarge",
                id: expert.id!,
                cssclass: "tilebutton",
                ispinned: false
            };
        });
    }

  activateLink(expert: ExpertsItem) {
        if (expert.routerLink) {
            this.router.navigate([expert.routerLink], { relativeTo: this.route });
        } else {
            window.open(expert.actionUrl, expert.target, 'noreferrer');
        }
    }

    public addTileToast(event: Tile) {
        /*this.toaster.show('Tile Pinned', 'Tile ' + event.title + ', with id: ' + event.id + ' was changed to ' + (event.ispinned ? 'pinned' : 'unpinned'), 5000);*/
        this.toaster.show('Tile Pinned', 'Tile ' + event.title + ' was changed to ' + (event.ispinned ? 'pinned' : 'unpinned'), 1000);
    }

    getTiles(): Tile[] {
        return this.experts.map((expert) => {
            var tile = expert.tile;
            tile.data = expert;
            return tile;
        });
    }

    orderChange(event: ITileOrder[]) {
    }
    closeVideoPopup(ev: any) {
        this.showPopup = false;
    }

}
